import * as React from "react";
import { useState, useEffect,createContext,useContext  } from 'react';
import { TileLayout } from "@progress/kendo-react-layout";
import CalendarScheduler from "./calendar";
import BenchmarkingPerf from "./benchmarkingPerf";
import AumChart from "./aum-chart";
import FamilyGrid from "./family-grid";
import OverView from "./overview-grid";
import TopFundGrid from "./topFund-grid";
import ClientStatement from "./cs-grid";
import TotalInvestment from "./totalInvestment";
import high from './data/2010_.json';
import low from './data/2018_.json';
import mid from './data/2015_.json';
//import donut from './data/donutData.json';
import overview from './data/overviewData.json';
import family from './data/familyData.json';
import clients from './data/csData.json';
import Settingicon from '../asset/Images/settings.svg';
import Searchicon from '../asset/Images/search.svg';
import Filtericon from '../asset/Images/filter-1.svg';
import Composite from './composite'
import Portfolio from './portfolio'
import stared from "../asset/returnsandstatistics/images/burger-menu.svg";
import close from "../asset/Images/close-icon.png";
import './Home.css';
import { Link, useNavigate, useParams } from "react-router-dom";
import { Profile } from './profile'
import { UrlPath } from "../../config/routeConfig";
import {
  DownloadDocument,
  GetCSDocumentsAPI,
  getFirmSummary,
  getFamilySummary,
  getMgmtSummary,
  getClassiSummary,
  getCustomSettings,
  updateCustomSettings,
  getFamilies,
  getUserPageAccess,
} from "../../config/apiConfig";
import axios from "axios";
import { HomePageTopBar } from "../shared/topBar/TopBar";
import { sbaAxios } from "../utils/sbaAxios";
import { HomeTaskBoard } from "./taskBoard";
import { SBTaskBoard } from "../UiComponents/SBTaskBoard";
import moment from "moment";
import { ToastContainer } from "react-toastify";
import RecentActivities from "./RecentActivities";
import { LoadingScreen } from "../UiComponents/LoadingComponent";
import { SBNotify } from "../utils/sbNotify";
import { Services } from "./services";
import InvestmentView from "./investmentView";

export  const WidgetCollectionContext = createContext();


export const HomeDashboard = () => {

  const todayDate = new Date();
  const previousMonthEndDate = new Date(todayDate.getFullYear(), todayDate.getMonth(), 0);
  const [options,setOptions ]=  useState( [
  ]);
  const [selectedOption, setSelectedOption] = useState();
  const [firmSummaryData, setFirmSummaryData] = useState([]);
  const [compositeView, setCompositeView] = useState(true);
  const [portfolioView, setPortfolioView] = useState(false);
  const [compositebuttonActive, setCompositebuttonActive] = useState(true);
  const [portfoliobuttonActive, setPortfoliobuttonActive] = useState(false);
  const [aumSelectedButton, setAumButton] = useState(0);
  const [raButton, setRaButton] = useState(0);
  const [csDocuments, setCSDocuments] = useState([]);
  const [familySummary, setFamilySummary] = useState([]);
  const [isAdvised, setIsAdvised] = useState(false);
  const [aumData, setAumData] = useState([]);
  const [classifyButtonIndex, setClassifyButtonIndex] = useState(0);
  const [parentClassId, setParentClassId] = useState(14);
  const [donut, setDonut] = useState([]);

  const [toCustomize, setToCustomize] = useState(false);
  const [customSetting, setCustomSetting] = useState([]);
  const [isSettingLoading, setIsSetLoading] = useState(true);
  const [render, setRender] = useState(0);
  const [data, setData] = useState([
    { col: 1, colSpan: 2, rowSpan: 2 },
    { col: 3, colSpan: 2, rowSpan: 2 },
    { col: 1, colSpan: 2, rowSpan: 2 },
    { col: 3, colSpan: 2, rowSpan: 2 },
    { col: 1, colSpan: 2, rowSpan: 2 },
    { col: 3, colSpan: 2, rowSpan: 2 },
    { col: 1, colSpan: 2, rowSpan: 1 },
    { col: 3, colSpan: 2, rowSpan: 1 },
    { col: 1, colSpan: 2, rowSpan: 1 }
  ]);
  const [addRemovedWidget, setAddRemovedWidget] = useState([]); 
  const removeWidget = (num) => {
    setTitle(val => val.map(item => {
      if (item.id == num) {
        return { ...item, isRemoved: true };
      }
      else
        return item
    }))
  };

  // useEffect(() => {
  //   if (options.length > 0) {
  //     setSelectedOption(options[0].value)
  //   }
  // }, [options]);
 
 
  const [tiles, setTitle] = useState([
    {
      id: 1,
      header: <div className="customHeaderSection"></div>,
      body: <FamilyGrid  />,
      sortOrder: 1,
      isRemoved: false,
      resizable: false
    },
    {
      id: 2,
      header: <div className="customHeaderSection"></div>,
      body: <ClientStatement data={csDocuments} />,
      sortOrder: 2,
      isRemoved: false,
      resizable: false
    },
    {
      id: 3,
      header: <div className="customHeaderSection"></div>,
      body: <AumChart />,
      sortOrder: 3,
      isRemoved: false,
      resizable: false
    },
    {
      id: 4,
      header: <div className="customHeaderSection"></div>,
      body: <TotalInvestment />,
      sortOrder: 4,
      isRemoved: false,
      resizable: false
    },
    {
      id: 5,
      header: <div className="customHeaderSection"></div>,
      body: <RecentActivities bIndex={raButton}></RecentActivities>,
      sortOrder: 5,
      isRemoved: false,
      resizable: false
    }
  ]);
  const getHomeDashBoardSettings = () => {
    sbaAxios({ url: getCustomSettings + "1026" }).then(res => {
      setCustomSetting(JSON.parse(res?.CustomSettingsValue || []));
      setTitle(valuee => {
        const updatedVal = valuee.map(val => {
          const value = JSON.parse(res?.CustomSettingsValue || []).find(item => item.componentId == val.id);
          return { ...val, sortOrder: value.SortOrder, isRemoved: value.IsRemoved, defaultPosition: value.dataPosition }
        });
        return updatedVal;
      });
      if ((res?.CustomFilterValue || '{}') != '{}')
        setData(JSON.parse(res?.CustomFilterValue || {}));
      setIsSetLoading(false);
      setRender(val => val + 1);
    }).catch(err => {
      console.log(err, 'Error Occured While retriving the User Setting')
    })
  };
  const getDashBoardViewAccess = async () => {
    try {
      const dashboardKeys = [
        { key: "FirmDashboardAccess", value: "Firm" },
        { key: "FamilyDashboardAccess", value: "Family" },
        { key: "ServicesDashboardAccess", value: "Services" },
        { key: "InvestmentDashboardAccess", value: "Investment" }
      ];
  
      // Execute all API calls in parallel
      const responses = await Promise.all(
        dashboardKeys.map(({ key }) =>
          sbaAxios({ url: `${getUserPageAccess}?keyName=${key}` }).catch(() => null)
        )
      );
  
      // Filter successful responses and create view array
      const view = responses
        .map((res, index) => (res ? { value: dashboardKeys[index].value, label: dashboardKeys[index].value } : null))
        .filter(Boolean);
  
      // Update state based on results
      if (view.length > 0) {
        setSelectedOption(view[0].value);
      }
      setOptions(view);
    } catch (error) {
      console.error("Error fetching dashboard access:", error);
      setOptions([]);
    }
  };
  
  useEffect(() => {
    document.title = `Home`;
    setIsSetLoading(true);
    setTimeout(() => {
      getHomeDashBoardSettings();
    }, 1000);
    getDashBoardViewAccess();
  }, []);
  const addWidgets = () => {
    setTitle(value => {
      return value.map(val => {
        if (val.isRemoved) {
          val.isRemoved = !addRemovedWidget.find(itemm => itemm.componentId == val.id)?.checked;
        }
        return val
      })
    })
    setAddRemovedWidget([]);
  };
  const [familyList, setFamilyList] = useState([]);
  const [selectedFamily, setSelectedFamily] = useState(null);

  useEffect(() => {

  }, [selectedFamily])
  useEffect(() => {
    sbaAxios({ url: getFamilies }).then(res => {
      setFamilyList(res);
      if (res.length > 0)
        setSelectedFamily(res.find(item => item.FamilyId == 1) || res[0])
    }).catch(re => {
      setFamilyList([]);
      console.log(re, 'Error Occured While fetching family data')
    })
  }, [])

  const handleReposition = e => {
    setData(e.value);
  };

  const optionChange = (event) => {
    setSelectedOption(event.value.label);
  };
  const saveWidgetCustomize = () => {
    const reTitles = tiles.reduce((acc, obj) => {
      acc[obj.id] = obj.isRemoved;
      return acc;
    }, {});
    const dataToBeSaved = defaultCollection.map(item => {
      return { ...item, IsRemoved: reTitles[item.componentId] }
    });
    const saveData = {
      "componentId": 1026,
      "componentUserSettingId": 0,
      "userId": 0,
      "customSettingsValue": JSON.stringify(dataToBeSaved),
      "isGrid": false,
      "customFilterValue": JSON.stringify(data)
    };
    sbaAxios({ url: updateCustomSettings, method: 'post', data: saveData }).then(res => {
      SBNotify({ Msg: "Custom Setting Saved Succesfully" });
    });
    setTitle(val => val.filter(item => item.id != 0));
    setToCustomize(false);
  };
  const CompositeValue = () => {
    setCompositeView(true);
    setPortfolioView(false);
    setCompositebuttonActive(true);
    setPortfoliobuttonActive(false);
  };
  const PortfolioValue = () => {
    setCompositeView(false);
    setPortfolioView(true);
    setCompositebuttonActive(false);
    setPortfoliobuttonActive(true);
  };
  const FilterOptions = () => {


    return (
      <>
        <HomePageTopBar options={options} selectedFamily={selectedFamily} setSelectedFamily={setSelectedFamily} familyList={familyList} selectedOption={selectedOption} optionChange={optionChange} compositebuttonActive={compositebuttonActive} portfoliobuttonActive={portfoliobuttonActive} CompositeValue={CompositeValue} PortfolioValue={PortfolioValue} Searchicon={Searchicon} Filtericon={Filtericon} />
      </>
    )
  };
  const getFirmSummaryData = async () => {
    try {
      let response;
      response = await sbaAxios({ url: `${getFirmSummary}` });
      setFirmSummaryData(response);
    } catch (error) {
      console.error(error);
    }
  };
 

  const fetchFamilySummary = async () => {
    try {
      const list = await sbaAxios({
        url: getFamilySummary,
        params: {
          advised: isAdvised
        }
      });
      setFamilySummary(list);
    }
    catch (e) {
      setFamilySummary([]);
    }
  };

  const fetchMgmtSummary = async () => {
    try {
      const list = await sbaAxios({
        url: getMgmtSummary,
        params: {
          enumerate: aumSelectedButton
        }
      });
      setAumData(list);
    }
    catch (e) {
      setAumData([]);
    }
  };

  const fetchClassificationSummary = async () => {
    try {
      const list = await sbaAxios({
        url: getClassiSummary,
        params: {
          parentClassId: parentClassId
        }
      });
      setDonut(list);
    }
    catch (e) {
      setDonut([]);
    }
  };



  useEffect(() => {
    getFirmSummaryData();
    // geDashboardCSDocuments();
  }, []);


  const FormatCurrencyGrid = (params) => {

    var num = params;
    if (num !== undefined && num != null) {
      if (num === 0) {
        return 0;
      } else {

        const formattedValue = `${num.toLocaleString('en-US', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        })}`;


        return formattedValue
      }
    }
    else {
      return <span></span>;
    }
  };
  const customizeWidget = () => {
    setToCustomize(true)
    // const values = [...tiles, additionalTile];
    // setTitle(val => values);
  };
  const RemovedWidgets = () => {
    return (
      <div class="row">
        {tiles.map(function (item, index) {
          if (item.isRemoved === true) {
            return (
              <div className="col-sm-4 col-md-4">
                <div className="widget-checkbox rounded">
                  <div className="form-check float-end">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id={item.id}
                      onChange={(e) => {
                        const val = e.target.checked
                        const componentId = item.id
                        const componentVal = {
                          componentId: componentId,
                          checked: val
                        }
                        setAddRemovedWidget(velu => {
                          if (velu.find(item => item.componentId == componentVal.componentId)) {
                            velu = velu.filter(item => item.componentId != componentVal.componentId);
                          }
                          return [...velu, componentVal];
                        })
                      }}
                      checked={addRemovedWidget.find(items => items?.componentId == item.id)?.checked}
                    />
                  </div>
                </div>
                <span className="mt-2 d-inline-block">{defaultCollection[index].WidgetName}</span>
              </div>
            );
          }
          return null;
        })}
      </div>
    );
  };
  return (<>
  <WidgetCollectionContext.Provider value={{ removeWidget , toCustomize}} >

  <div  className="dashboard p-3 home">
    <FilterOptions />
   <div className="mainContentData mt-4">
     
        {selectedOption === "Firm" && (<>
          <div className="row m-0 ">
        <div className="col-md-8">
          <h2 className="fs-5 fw-semibold">Overview</h2>
        </div>
        <div className="col-md-4">
          <div className="d-flex align-items-center gap-2">
            <select className="form-select" aria-label="Default select example" disabled>
              <option selected>Default Style</option>
              <option value="1">Dashboard Style 2</option>
              <option value="3">Dashboard Style 3</option>
              <option value="4">Dashboard Style 4</option>
              <option value="4">Create New Dashboard</option>
            </select>
            {/* <div className="dropdown">
              <a className="dropdown-toggle setting" href="#" role="button" data-bs-toggle="dropdown"
                  aria-expanded="false">
                  <img src={Settingicon} title="Customize Dashboard" alt=""/>
              </a>
              {/* <ul className="dropdown-menu">
                  <li><a className="dropdown-item" >Customize Dashboard</a></li>
              </ul> */}
            {/*</div> */}
            <div className="d-flex gap-2" style={{ fontSize: '20px' }}>
              {!toCustomize ? <>
                <i class="fa-solid fa-gear SBA_hand" title="Customize Dashboard" onClick={() => { customizeWidget() }}></i>

              </> : <> <i className="fa-solid fa-floppy-disk SBA_hand" title="Save" onClick={() => { saveWidgetCustomize() }}></i>
                <i className="fa-solid fa-ban SBA_hand" title="Cancel" onClick={() => { setTitle(val => val.filter(item => item.id != 0)); setToCustomize(false); getHomeDashBoardSettings() }}></i></>}
            </div>
          </div>
        </div>
      </div>
          <div className="row mt-3">
          <div className="d-flex flex-md-wrap mt-3 gap-3">
            <div className="bg-white flex-grow-1 p-3 rounded board-border board">
              <p className="mb-8">Asset Under Management</p>
              <span className="secondary-color fs-5 fw-semibold">$ {FormatCurrencyGrid(firmSummaryData?.AssetsUnderMgmt)}</span>
            </div>
            <div className="bg-white flex-grow-1 p-3 rounded board-border board">
              <p className="mb-8">Total Revenue Generated</p>
              <span className="secondary-color fs-5 fw-semibold">$ {FormatCurrencyGrid(firmSummaryData?.Revenue)}</span>
            </div>
            <div className="bg-white flex-grow-1 p-3 rounded board-border board">
              <p className="mb-8">No. of Families</p>
              <span className="secondary-color fs-5 fw-semibold">{firmSummaryData?.NumberofFamilies}</span>
            </div>
            <div className="bg-white flex-grow-1 p-3 rounded board-border board">
              <p className="mb-8">Total No. of Composites</p>
              <span className="secondary-color fs-5 fw-semibold">{firmSummaryData?.NumberofComposites}</span>
            </div>
            <div className="bg-white flex-grow-1 p-3 rounded board-border board">
              <p className="mb-8">Total No. of Portfolios</p>
              <span className="secondary-color fs-5 fw-semibold">{firmSummaryData?.NumberofPortfolios}</span>
            </div>
          </div>
          <WidgetSection toCustomize={toCustomize} data={data} handleReposition={handleReposition} tiles={tiles} isSettingLoading={isSettingLoading}/>
        </div></>)}
        {selectedOption === "Board" && (<>
          <div className="row m-0 ">
        <div className="col-md-8">
          <h2 className="fs-5 fw-semibold">Overview</h2>
        </div>
        <div className="col-md-4">
          <div className="d-flex align-items-center gap-2">
            <select className="form-select" aria-label="Default select example" disabled>
              <option selected>Default Style</option>
              <option value="1">Dashboard Style 2</option>
              <option value="3">Dashboard Style 3</option>
              <option value="4">Dashboard Style 4</option>
              <option value="4">Create New Dashboard</option>
            </select>
            {/* <div className="dropdown">
              <a className="dropdown-toggle setting" href="#" role="button" data-bs-toggle="dropdown"
                  aria-expanded="false">
                  <img src={Settingicon} title="Customize Dashboard" alt=""/>
              </a>
              {/* <ul className="dropdown-menu">
                  <li><a className="dropdown-item" >Customize Dashboard</a></li>
              </ul> */}
            {/*</div> */}
          </div>
        </div>
      </div>
        <div className="row mt-3">
          
          <SBTaskBoard /></div>
        </>)}
        {compositeView && selectedOption === "Family" && (<>
          <div className="row m-0 ">
        <div className="col-md-8">
          <h2 className="fs-5 fw-semibold">Overview</h2>
        </div>
        <div className="col-md-4">
          <div className="d-flex align-items-center gap-2">
            <select className="form-select" aria-label="Default select example" disabled>
              <option selected>Default Style</option>
              <option value="1">Dashboard Style 2</option>
              <option value="3">Dashboard Style 3</option>
              <option value="4">Dashboard Style 4</option>
              <option value="4">Create New Dashboard</option>
            </select>
            {/* <div className="dropdown">
              <a className="dropdown-toggle setting" href="#" role="button" data-bs-toggle="dropdown"
                  aria-expanded="false">
                  <img src={Settingicon} title="Customize Dashboard" alt=""/>
              </a>
              {/* <ul className="dropdown-menu">
                  <li><a className="dropdown-item" >Customize Dashboard</a></li>
              </ul> */}
            {/*</div> */}
          </div>
        </div>
      </div>
      <div className="row mt-3">
          <div>
            <Composite selectedFamily={selectedFamily} />
          </div>
          </div>
        </>)}
        {portfolioView && selectedOption === "Family" && (<>
          <div className="row m-0 ">
        <div className="col-md-8">
          <h2 className="fs-5 fw-semibold">Overview</h2>
        </div>
        <div className="col-md-4">
          <div className="d-flex align-items-center gap-2">
            <select className="form-select" aria-label="Default select example" disabled>
              <option selected>Default Style</option>
              <option value="1">Dashboard Style 2</option>
              <option value="3">Dashboard Style 3</option>
              <option value="4">Dashboard Style 4</option>
              <option value="4">Create New Dashboard</option>
            </select>
            {/* <div className="dropdown">
              <a className="dropdown-toggle setting" href="#" role="button" data-bs-toggle="dropdown"
                  aria-expanded="false">
                  <img src={Settingicon} title="Customize Dashboard" alt=""/>
              </a>
              {/* <ul className="dropdown-menu">
                  <li><a className="dropdown-item" >Customize Dashboard</a></li>
              </ul> */}
            {/*</div> */}
          </div>
        </div>
      </div>
          <div className="row mt-3">
          <div>
            <Portfolio />
          </div>
          </div>
        </>)}
        {selectedOption === "Services" && (<>
          <div className="row m-0 ">
        <div className="col-md-8">
          <h2 className="fs-5 fw-semibold">Overview</h2>
        </div>
        <div className="col-md-4">
          <div className="d-flex align-items-center gap-2">
            <select className="form-select" aria-label="Default select example" disabled>
              <option selected>Default Style</option>
              <option value="1">Dashboard Style 2</option>
              <option value="3">Dashboard Style 3</option>
              <option value="4">Dashboard Style 4</option>
              <option value="4">Create New Dashboard</option>
            </select>
            {/* <div className="dropdown">
              <a className="dropdown-toggle setting" href="#" role="button" data-bs-toggle="dropdown"
                  aria-expanded="false">
                  <img src={Settingicon} title="Customize Dashboard" alt=""/>
              </a>
              {/* <ul className="dropdown-menu">
                  <li><a className="dropdown-item" >Customize Dashboard</a></li>
              </ul> */}
            {/*</div> */}
          </div>
        </div>
      </div>
          <div className="row mt-3">
          <><Services/></>
          </div>

        </>)}
        {selectedOption === "Investment" && (<>
        
          <div className="row mt-3">
          <><InvestmentView/></>
          </div>
        </>)}
      </div>
    </div>
    {toCustomize && <>
      <div class="modal fade" id="exampleModal" tabindex="-1"
      aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div
        class="modal-dialog modal-dialog-centered modal-dialog-scrollable widget-add-modal">
        <div class="modal-content p-2 overflow-auto">
          <div class="modal-header">
            <h1 class="modal-title fs-5" id="exampleModalLabel">Add Widgets
            </h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal"
              aria-label="Close"></button>
          </div>
          <form>
            <div class="modal-body ">
              <h6 class="fw-medium fs-6 mt-3">Click on the widget checkbox
                to
                add
              </h6>
              <RemovedWidgets />
            </div>
            <div class="modal-footer border-0">
              <button type="button" class="cancel-btn"
                data-bs-dismiss="modal" onClick={() => { setAddRemovedWidget([]) }}>Cancel</button>
              <button type="button" class="apply-btn"
                onClick={() => addWidgets()}
                data-bs-dismiss="modal">Apply</button>
            </div>
          </form>
        </div>
      </div>
    </div>
    </>}
    <ToastContainer></ToastContainer>

  </WidgetCollectionContext.Provider>
   
  </>
  )
};




const defaultCollection = [
  {
    WidgetName: 'Families',
    SortOrder: 1,
    componentId: 1,
    IsRemoved: false,
    TitleName: 'Families',
    WidgetId: 'Families',
    dataPosition: { order: 0, rowSpan: 2, colSpan: 1, col: 1 }
  },
  {
    WidgetName: 'ClientStatement',
    SortOrder: 2,
    componentId: 2,
    IsRemoved: false,
    TitleName: 'Client Statement',
    WidgetId: 'ClientStatement',
    dataPosition: { order: 1, rowSpan: 2, colSpan: 1, col: 2 }
  },
  {
    WidgetName: 'AUM',
    SortOrder: 3,
    componentId: 3,
    IsRemoved: false,
    TitleName: 'AUM',
    WidgetId: 'AUM',
    dataPosition: { order: 2, rowSpan: 2, colSpan: 1, col: 3 }
  },
  {
    WidgetName: 'StrategyAllocation',
    SortOrder: 4,
    componentId: 4,
    IsRemoved: false,
    TitleName: 'Strategy Allocation',
    WidgetId: 'StrategyAllocation',
    dataPosition: { order: 3, rowSpan: 2, colSpan: 1, col: 1 }
  },
  {
    WidgetName: 'RecentActivities',
    SortOrder: 5,
    componentId: 5,
    IsRemoved: true,
    TitleName: 'Recent Activities',
    WidgetId: 'RecentActivities',
    dataPosition: { order: 4, rowSpan: 2, colSpan: 1, col: 2 }
  }
]



const WidgetSection = ({ toCustomize,handleReposition,tiles,isSettingLoading,data}) => {
  const filteredTiles = tiles.filter(item => !item.isRemoved);
  const additionalTile = {
    body: (
      <div class="col-md-6 col-lg-4">
        <div class="card" style={{ width: "300%" }}>
          <div class="add-widget h-300">
            <button class="d-inline-block w-100 h-100 fs-5"
              data-bs-toggle="modal" data-bs-target="#exampleModal">
              + Add a Widget
            </button>
          </div>
        </div>
      </div>
    ),
    defaultPosition: null,
    resizable: false,
    reorderable: false,
    id: 0
  };
  const titeCollection = toCustomize 
    ? filteredTiles.length < defaultCollection.length
      ? [...filteredTiles, additionalTile]
      : filteredTiles
    : filteredTiles;
  
 return <>
    <div style={{ visibility: isSettingLoading ? 'visible' : 'hidden', maxHeight: isSettingLoading ? 'unset' : '0.1px', maxWidth: isSettingLoading ? 'unset' : '0.1px' }} >
      <LoadingScreen />
    </div>
    {!isSettingLoading && 
    <div id="assettile" className="dashboard" style={{ visibility: !isSettingLoading ? 'visible' : 'hidden', position: !isSettingLoading ? 'unset' : 'absolute', maxHeight: !isSettingLoading ? 'unset' : '0.1px', maxWidth: !isSettingLoading ? 'unset' : '0.1px', userSelect: 'none' }}>
    <TileLayout 
    columns={4} 
    rowHeight={255} 
    positions={data}
    gap={{
      rows: 10,
      columns: 10
    }}
    items={titeCollection} 
    onReposition={handleReposition} />
  </div>
    }
    
  </>
};